import { render, staticRenderFns } from "./ContextMenuGroup.vue?vue&type=template&id=382484b2&scoped=true&lang=pug&"
import script from "./ContextMenuGroup.vue?vue&type=script&lang=js&"
export * from "./ContextMenuGroup.vue?vue&type=script&lang=js&"
import style0 from "./ContextMenuGroup.vue?vue&type=style&index=0&id=382484b2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382484b2",
  null
  
)

export default component.exports